import { PageContainer } from "@/components/page-container";
import { Button, Tab } from "@renderbus/ui";
import { useInitTabList } from "./hooks/useInitTabList";
import { ChildManagerType } from "./constant";
import { useNavigate } from "react-router-dom";
import { useGlobalStore } from "@/store/GlobalStore";
import { DisplaySubaccount } from "project-config/constants";
import {
  GotoEnterpriseTip,
  GotoEnterpriseTitle,
  GotoEnterpriseWrapper,
} from "./atom";
import { redirectToAuth } from "../profile/helper/redirectToAuth";
import SubManageImage from "@/assets/icons/auth/sub-manage";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function ChildCustomer() {
  const navigate = useNavigate();
  const { defaultChildTabsList, currentActiveTab, setCurrentActiveTab } =
    useInitTabList();
  const t = getTranslateNsT("childManager");
  const { userInfo, isDomestic } = useGlobalStore();
  return (
    <PageContainer>
      {userInfo?.displaySubaccount === DisplaySubaccount.Close && isDomestic ? (
        <GotoEnterpriseWrapper>
          <div>
            <GotoEnterpriseTitle>
              {t("dingdng_subaccount_manage")}
            </GotoEnterpriseTitle>
            <GotoEnterpriseTip>
              {t("dingdng_subaccount_manage_tip")}
            </GotoEnterpriseTip>
            <Button
              type="primary"
              onClick={() =>
                redirectToAuth(
                  userInfo,
                  false,
                  "/authenticate/enterprise-authenticate"
                )
              }
            >
              {t("dingdng_subaccount_auth_btn")}
            </Button>
          </div>
          <SubManageImage />
        </GotoEnterpriseWrapper>
      ) : (
        <Tab
          tabsList={defaultChildTabsList.filter((item) => item.visible)}
          activeKey={currentActiveTab}
          onChange={(k) => {
            setCurrentActiveTab(k as ChildManagerType);
            navigate(`/childCustomer?activeName=${k}`);
          }}
        />
      )}
    </PageContainer>
  );
}
